<kl-sidebar v-show="showSidebar" :class="{ 'kl-sidebar--sidebar-at-bottom': modSidebarAtBottom }">
    <template v-if="forGeometry">
        <kl-draw-zone-sidebar-geometry-info
            v-if="listZones && currentZone"
            :geometry-info="currentZone?.geometryInfo"
            :show-remove="showRemoveGeometry"
            @remove-geometry="onRemoveGeometry"
        />
        <kl-draw-zone-sidebar-geometry-actions
            v-if="listZones && !currentZone"
            @goto-create="onCreate"
            @goto-import="onZoneImport"
        />
        <kl-draw-zone-sidebar-import
            v-if="importZone && !showLambertImportWarning"
            title="Uw zone"
            :show-title="showSidebarTitle"
            :for-maprequest="false"
            :for-geometry="true"
            :mod-enable-multi-zones="modEnableMultiZones"
            :has-import-errors="hasImportErrors"
            :has-import-warnings="hasImportWarnings"
            :import-errors="importErrors"
            :import-more-info-link="importMoreInfoLink"
            :max-files-to-import="1"
            @cancel="onCancelImport"
            @files-uploaded="onFilesUploaded"
        />
        <kl-draw-zone-sidebar-import-lambert-warning
            v-if="importZone && showLambertImportWarning"
            :title="sidebarTitle"
            :show-title="showSidebarTitle"
            @cancel="onCancelImport"
            @continue="onContinueImport"
        />
        <kl-draw-zone-sidebar-geometry-create-edit
            v-if="createZone || editZone"
            title="Uw zone"
            :show-title="showSidebarTitle"
            :is-edit="editZone"
            @remove-geometry="onRemoveCurrentZone"
        />
    </template>

    <template v-else-if="forKlbZones">
        <kl-draw-zone-sidebar-klb-list
            :show-sidebar-title="showSidebarTitle"
            :sidebar-title="sidebarTitle"
            :can-add-klb-zone="canAddKlbZone"
            :can-add-klim-zone="canAddKlimZone"
            :zones="zones"
            :show-klb-archived-zone-toggle="showKlbArchivedZoneToggle"
            :klb-archived-zone-toggle-value="klbArchivedZoneToggleValue"
            @add-new-klb-zone="addNewKlbZone"
            @add-new-klim-zone="addNewKlimZone"
            @edit-klb-zone="editKlbZone"
            @highlight-klb-zone="onKlbZoneHover"
            @toggle-show-active="onKlbToggleShowActive"
        />
    </template>

    <!-- create || edit zone -->
    <template v-else-if="editZone || createZone">
        <!-- modSidebarAtBottom -->
        <template v-if="modSidebarAtBottom">
            <kl-draw-zone-sidebar-edit-zone-detail
                :only1-section="true"
                :current-zone-price="currentZonePrice"
                :current-zone-error="currentZoneError"
                :current-zone-detail-info="currentZoneDetailInfo"
                :current-polygon-feature-area-formatted="currentPolygonFeatureAreaFormatted"
            />
        </template>
        <!-- !modSidebarAtBottom -->
        <template v-else>
            <kl-draw-zone-sidebar-header v-if="showSidebarTitle" :title="sidebarTitle" tag-style="h5"/>

            <!-- CREATE: createZone -->
            <template v-if="createZone">
                <vl-sidebar-content class="kl-sidebar__section kl-sidebar__section-smaller">
                    <vl-title tag-name="h3" tag-style="h6" class="vl-sidebar-header__title kl-sidebar__section__fillrow">
                        Teken zone
                    </vl-title>
                    <vl-button v-if="!showFooterActions" type="button" mod-small mod-tertiary @click="onRevertCurrentZone">Annuleren</vl-button>
                </vl-sidebar-content>
                <vl-sidebar-content class="kl-sidebar__section kl-sidebar__section-larger kl-sidebar__section-reduced-separator">
                    <p class="kl-sidebar__section__fillrow" v-html="sidebarText"></p>
                </vl-sidebar-content>
            </template>

            <!-- EDIT: editZone -->
            <template v-if="editZone">
                <vl-sidebar-content class="kl-sidebar__section kl-sidebar__section-smaller" v-if="!editingZoneName">
                    <strong class="kl-sidebar__section__fillrow kl-sidebar__section__fillrow__clip">{{ zoneDetailTitle }}</strong>
                    <vl-button type="button" icon="pencil" mod-icon mod-secondary mod-large @click="onEditZoneName" v-if="canEditZoneName"/>
                </vl-sidebar-content>
                <vl-sidebar-content
                    class="kl-sidebar__section kl-sidebar__section-smaller kl-sidebar__section__edit-zone-name"
                    v-if="editZone && editingZoneName">
                    <vl-input-group class="kl-sidebar__section__fillrow">
                        <vl-input-field name="referentie" v-model="currentZoneName" mod-block @input="onInputZoneName"/>
                        <vl-button type="button" icon="check-small" mod-icon mod-narrow @click="onStopEditZoneName"
                                   :mod-disabled="editZoneNameHasValidationError"/>
                    </vl-input-group>
                    <div class="kl-sidebar__section__edit-zone-name__col-error" v-if="editZoneNameHasValidationError">
                        <span v-vl-text.bold.small.error>Uw referentie mag niet groter zijn dan 100 karakters</span>
                    </div>
                </vl-sidebar-content>
                <vl-sidebar-content class="kl-sidebar__section kl-sidebar__section-reduced-separator"
                                    v-if="zoneDetailDescription">
                    <p class="kl-sidebar__section__fillrow">{{ zoneDetailDescription }}</p>
                </vl-sidebar-content>
            </template>

            <!-- CREATE && EDIT -->
            <kl-draw-zone-sidebar-edit-zone-detail
                :only1-section="false"
                :current-zone-price="currentZonePrice"
                :current-zone-error="currentZoneError"
                :current-zone-detail-info="currentZoneDetailInfo"
                :current-polygon-feature-area-formatted="currentPolygonFeatureAreaFormatted"
            />

            <kl-draw-zone-sidebar-filler/>

            <!-- CREATE && EDIT FOOTER ACTIONS -->
            <kl-draw-zone-sidebar-edit-footer
                v-if="showFooterActions"
                ref="footerActions_leftSidebar"
                :is-remove-visible="isRemoveVisible"
                :is-confirm-visible="isConfirmVisible"
                :edit-zone="editZone"
                @confirm="onConfirm"
                @remove="onRemoveCurrentZone"
                @revert="onRevertCurrentZone"
            />

        </template>
    </template>
    <!-- create || edit zone -->

    <!-- import zone -->
    <template v-else-if="importZone" class="kl-sidebar__import-container">
        <kl-draw-zone-sidebar-import
            v-if="!showLambertImportWarning"
            :title="sidebarTitle"
            :show-title="showSidebarTitle"
            :for-maprequest="forMaprequest"
            :mod-enable-multi-zones="modEnableMultiZones"
            :has-import-errors="hasImportErrors"
            :has-import-warnings="hasImportWarnings"
            :import-errors="importErrors"
            :import-more-info-link="importMoreInfoLink"
            :max-files-to-import="maxFilesToImport"
            @cancel="onCancelImport"
            @files-uploaded="onFilesUploaded"
        />
        <kl-draw-zone-sidebar-import-lambert-warning
            v-if="showLambertImportWarning"
            :title="sidebarTitle"
            :show-title="showSidebarTitle"
            @cancel="onCancelImport"
            @continue="onContinueImport"
        />
    </template>

    <!-- list zones -->
    <template v-else-if="listZones">
        <kl-draw-zone-sidebar-header v-if="showSidebarTitle" :title="sidebarTitle" tag-style="h5"/>
        <vl-sidebar-content v-if="canAddMoreZones" class="kl-sidebar__section" ref="actions">
            <vl-action-group class="kl-sidebar__section__actions">
                <vl-button type="button" @click.prevent="onCreate" ref="drawButton" mod-small mod-block>
                    Teken zone
                </vl-button>
                <vl-button type="button" @click.prevent="onZoneImport" ref="importButton" mod-small mod-secondary mod-block>
                    {{ importButtonLabel }}
                </vl-button>
            </vl-action-group>
        </vl-sidebar-content>

        <vl-sidebar-content mod-container v-if="hasImportWarnings" class="kl-sidebar__section-warning">
            <div class="kl-sidebar__warning">
                <vl-title tag-style="h6" class="kl-sidebar__text18 kl-sidebar__margin-bottom5">Let op!</vl-title>
                <vl-button type="button" class="kl-sidebar__warning__close" icon="close" mod-icon mod-naked-action
                           @click="onCloseWarnings">

                </vl-button>
                <div>
                    <div class="kl-sidebar__text18 kl-sidebar__margin-bottom5" v-for="(warning) in importWarnings">
                        {{ warning }}
                    </div>
                </div>
            </div>
        </vl-sidebar-content>

        <kl-draw-zone-sidebar-filler v-if="!hasZones"/>

        <vl-sidebar-content mod-container v-if="hasZones" class="kl-sidebar__section-no-border-top">
            <perfect-scrollbar
                :options="{ suppressScrollX: true, suppressScrollY: false, wheelPropagation: false }"
                class="kl-sidebar__scroll-area"
            >
                <ul class="kl-sidebar__list">
                    <li class="kl-sidebar__section" v-for="(cz) in zones">
                        <vl-button type="button" mod-naked-action @click.prevent="edit(cz.id)" class="kl-sidebar__section__zone-summary">
                            <vl-link href="#" mod-bold>
                                <strong>{{ cz.name }}</strong>
                            </vl-link>
                            <div class="kl-sidebar__section__zone-summary__sub" v-if="getZoneListInfo(cz)"
                                 v-html="getZoneListInfo(cz)" v-vl-text.small></div>
                        </vl-button>
                        <div class="kl-sidebar__section__vertical-separator"></div>
                        <span v-if="cz.price" class="kl-sidebar__section__zone-price">
                            <strong>{{ formatCurrency(cz.price) }}</strong>
                        </span>
                        <vl-button v-if="!cz.price" type="button" class="kl-sidebar__section__zone-remove" icon="bin" mod-icon
                                   mod-naked-action mod-error mod-large @click="onRemoveZone(cz)"></vl-button>
                    </li>

                    <!-- IMKL -->
                    <li class="kl-sidebar__section" v-if="getTotalImklPrice()">
                        <div class="kl-sidebar__section__totaal">
                            <strong>{{ getImklDescription() }}</strong>
                        </div>
                        <div class="kl-sidebar__section__vertical-separator"></div>
                        <div class="kl-sidebar__section__zone-price">
                            <strong>{{ formatCurrency(getTotalImklPrice()) }}</strong>
                        </div>
                    </li>
                </ul>
            </perfect-scrollbar>
        </vl-sidebar-content>

        <vl-sidebar-footer class="kl-sidebar__section kl-sidebar__section-no-border-bottom"
                           v-if="modMaprequestZone && getTotalPrice()" ref="total">
            <div class="kl-sidebar__section__totaal vl-title vl-title--h5">
                <strong>TOTAAL <span v-if="applyVat" v-vl-text.small>excl. BTW</span></strong>
            </div>
            <div class="kl-sidebar__section__vertical-separator"></div>
            <div class="kl-sidebar__section__zone-price vl-title vl-title--h5">
                {{ formatCurrency(getTotalPrice()) }}
            </div>
        </vl-sidebar-footer>
    </template>
</kl-sidebar>
